/** @format */

import React, { createContext, useContext, useEffect, useState } from "react";
import { useToast } from "@chakra-ui/react";
import { getDistance } from "geolib";
import moment from "moment";
import { getLojas, getRecomendacao, postAtivaDesconto } from "../services/api";
import { formataEventosFiltros, removeAcento } from "../utils";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaHourglassStart,
  FaHourglassEnd,
} from "react-icons/fa";
import { usePersonalizacao } from "./usePersonalizacao";
import { useSession } from "./useSession";
import { useFirebase } from "./useFirebase";

const RecomendacaoContext = createContext();

export function RecomendacaoProvider({ children }) {
  moment.locale("pt-br");

  const { session } = useSession();
  const { analyticsEvent } = useFirebase();

  const toast = useToast();
  const {
    personalizacao: { guiaofertas, isDefaultWeb, apiAtivaDescontoDev, apiRecomendacaoDev },
  } = usePersonalizacao();

  const lojaselecionadaStorage = JSON.parse(
    localStorage.getItem("@LojaSelecionada::")
  );

  const destaquesLabel = guiaofertas?.nometabs?.destaques;
  const ofertasLabel = guiaofertas?.nometabs?.ofertas;
  const cashbackLabel = guiaofertas?.nometabs?.cashback;
  const descontoExclusivoLabel = guiaofertas?.nometabs?.descontoexclusivo;

  const [recomendacao, setRecomendacao] = useState([]);
  const [filteredRecomendacao, setFilteredRecomendacao] = useState([]);
  const [selectedFiltros, setSelectedFiltros] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [loja, setLoja] = useState({
    idLoja: lojaselecionadaStorage?.idLoja || "0",
    nomeLoja: lojaselecionadaStorage?.nomeLoja || "",
    nomeLojaSelecionada: lojaselecionadaStorage?.nomeLojaSelecionada || "",
  });
  const [selectedOferta, setSelectedOferta] = useState({});
  const [lojas, setLojas] = useState([]);
  const [inputSearch, setInputSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const filtros = [
    {
      id: 8,
      label: "Ofertas Ativadas",
      ativado: true,
    },
    {
      id: 4,
      label: "Destaque",
      id_classificacao_topete: "1",
    },
    {
      id: 1,
      label: descontoExclusivoLabel,
      idtiporecomendacao: "1",
    },
    {
      id: 3,
      label: ofertasLabel,
      idtiporecomendacao: "2",
    },
    {
      id: 2,
      label: cashbackLabel,
      idtiporecomendacao: "3",
    },
    {
      id: 5,
      label: "Para você",
      id_classificacao_topete: "2",
    },
    {
      id: 6,
      label: "Clube",
      clube: true,
    },
    {
      id: 7,
      label: "Vai expirar em breve",
      expira: true,
    },
  ];
  const ordenacao = [
    {
      id: 1,
      label: "A - Z",
      title: "A - Z",
      icon: ({ color, style }) => (
        <FaArrowAltCircleDown style={style} size={20} color={color} />
      ),
    },
    {
      id: 2,
      label: "Z - A",
      title: "Z - A",
      icon: ({ color, style }) => (
        <FaArrowAltCircleUp style={style} size={20} color={color} />
      ),
    },
    {
      id: 3,
      label: "Ofertas recentes",
      title: "Recentes",
      icon: ({ color, style }) => (
        <FaHourglassStart style={style} size={20} color={color} />
      ),
    },
    {
      id: 4,
      label: "Ofertas acabando",
      title: "Acabando",
      icon: ({ color, style }) => (
        <FaHourglassEnd style={style} size={20} color={color} />
      ),
    },
  ];

  useEffect(() => {
    if (
      window.location.pathname !== "/autenticacao" &&
      session.idvarejista &&
      isDefaultWeb === undefined
    ) {
      requestRecomendacao();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loja.idLoja, session, isDefaultWeb]);

  useEffect(() => {
    if (window.location.pathname !== "/autenticacao" && session.idvarejista) {
      updateWithFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiltros, recomendacao, session]);

  useEffect(() => {
    if (window.location.pathname !== "/autenticacao" && session.idvarejista && session.xapikey) {
      getLojas
        .post("", "", {
          headers: {
            idvarejista: session.idvarejista,
            "x-api-key": session.xapikey,
          },
        })
        .then((response) => {
          const idLojas = [];
          const idLojasComRecomendacao = [];
          for (let i = 0; i < response.data.length; i++) {
            idLojas.push(`"${response.data[i].id}"`);
          }

          if(idLojas.length > 50) {
            getDistanceFromLoja({lojas: response.data})
            const loja = response.data.filter(data => data.id === session.idloja)[0]
            handleChangeLoja(loja);
            return;
          }

          const endpointApi = !!apiRecomendacaoDev && apiRecomendacaoDev === true ? '/dev/ofertas' : '/v2/ofertas'

          getRecomendacao(endpointApi, {
            params: {
              cpfcnpj: session.cpfcnpj,
              idtiporecomendacao: `['1', '2', '3']`,
              lojas: `[${idLojas}]`,
            },
            headers: {
              idvarejista: session.idvarejista,
              "x-api-key": session.xapikey,
            },
          }).then((data) => {
            const lojasRecomendacao = data.data.map((lojas) => lojas);

            for (let i = 0; i < lojasRecomendacao.length; i++) {
              for (let y = 0; y < lojasRecomendacao[i].lojas.length; y++) {
                if (
                  !idLojasComRecomendacao.includes(
                    lojasRecomendacao[i].lojas[y]
                  )
                ) {
                  idLojasComRecomendacao.push(lojasRecomendacao[i].lojas[y]);
                }
              }
            }

            if (idLojasComRecomendacao.includes("0")) {
              if (session.idloja) {
                let filter = response.data.filter(
                  (data) => data.id === session.idloja
                )[0];
                handleChangeLoja(filter);
              }

              getDistanceFromLoja({ lojas: response.data });
            } else {
              const filteredLojas = response.data.filter(function (
                element,
                index,
                array
              ) {
                if (idLojasComRecomendacao.includes(element.id)) {
                  return element;
                } else {
                  return null;
                }
              });

              if (!idLojasComRecomendacao.includes(session.idloja)) {
                console.log(idLojasComRecomendacao)
                let defaultLoja = {
                  idLoja: "0",
                  nomeLoja: "",
                  nomeLojaSelecionada: "",
                };
                handleChangeLoja(defaultLoja);
              } else if (
                session.idloja &&
                idLojasComRecomendacao.filter((id) => id === session.idloja)
                  .length > 0
              ) {
                handleChangeLoja(filteredLojas.filter(data => data.id === session.idloja)[0]);
              }

              getDistanceFromLoja({ lojas: filteredLojas });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  async function getDistanceFromLoja({ lojas }) {
    const { latitude, longitude } = session;

    if (latitude && longitude) {
      try {
        const newLojas = lojas;
        const newDistLojas = lojas.map((data) => {
          return { lat: data.lat, lon: data.lon };
        });

        for (let i = 0; i < lojas.length; i++) {
          if (newDistLojas[i].lat && newDistLojas[i].lon) {
            const distances = getDistance(
              {
                latitude: Number(newDistLojas[i].lat),
                longitude: Number(newDistLojas[i].lon),
              },
              { latitude: latitude, longitude: longitude }
            );
            if (distances > 1000) {
              const newDistanceFormated = (distances / 1000).toFixed(1) + " km";
              newLojas[i] = {
                ...newLojas[i],
                distancia: distances,
                distanciaFormatada: newDistanceFormated,
              };
            } else {
              const newDistanceFormated = distances + " mt";
              newLojas[i] = {
                ...newLojas[i],
                distancia: distances,
                distanciaFormatada: newDistanceFormated,
              };
            }
          } else {
            newLojas[i] = { ...newLojas[i], distancia: "0 " };
          }
        }

        const ordenaLojasDistancia = newLojas.sort((a, b) => {
          return parseInt(a.distancia) - parseInt(b.distancia);
        });

        setLojas(ordenaLojasDistancia);
        return true;
      } catch (err) {
        console.log(err);
      }
    } else {
      const newLojas = lojas;
      const ordenaLojasOrdemAlfabética = newLojas.sort(function (a, b) {
        if (
          removeAcento(a.nome.toLowerCase()) <
          removeAcento(b.nome.toLowerCase())
        ) {
          return -1;
        } else {
          return true;
        }
      });

      setLojas(ordenaLojasOrdemAlfabética);
    }
  }

  const requestRecomendacao = async () => {
    try {
      if (!isLoading) {
        let loadingState = true;
        setIsLoading(loadingState);
        toast.closeAll();
        setTimeout(() => {
          if (!toast.isActive("recomendacao")) {
            toast({
              id: "recomendacao",
              title: "Atualizando...",
              description: "Atualizando suas ofertas, aguarde.",
              status: "info",
              duration: 10000,
              isClosable: true,
            });
          }
        }, 100);

        const endpointApi = !!apiRecomendacaoDev && apiRecomendacaoDev === true ? '/dev/ofertas' : '/v2/ofertas'
  
        const response = await getRecomendacao(endpointApi, {
          params: {
            cpfcnpj: session.cpfcnpj,
            idtiporecomendacao: `['1', '2', '3']`,
            lojas: `['${loja.idLoja}']`,
          },
          headers: {
            idvarejista: session.idvarejista,
            "x-api-key": session.xapikey,
            "content-type": "application/json"
          },
        });
        if (response.status === 200) {
          toast.close("recomendacao");
          if (!toast.isActive("recomendacao-atualizado")) {
            setTimeout(() => {
              toast({
                id: "recomendacao-atualizado",
                title: "Atualizado!",
                description: "Ofertas atualizadas com sucesso",
                status: "success",
                duration: 2000,
                isClosable: true,
              });
            }, 0);
            setIsLoading(false);
          }
          setRecomendacao(response.data);
        } else {
          toast.closeAll();
          if (!toast.isActive("recomendacao-error")) {
            toast({
              id: "recomendacao-error",
              title: "Opss...",
              description:
                "Houve um problema ao atualizar as ofertas, tente novamente.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
            setIsLoading(false);
          }
          console.log("Error");
        }
      }
    } catch (err) {
      console.log(err)
    }
  };

  const ativaDesconto = async ({ idoferta }) => {
    const newRecomendacao = recomendacao;
    let indexProduto = newRecomendacao.findIndex(
      (data) => data.idoferta === idoferta
    );
    let newTime = moment(new Date()).format("HH:mm:ss");
    let newDate = new Date().toISOString();

    try {
      newRecomendacao[indexProduto].ativado = "loading";
      newRecomendacao[indexProduto].dataativacao = newDate + " " + newTime;
      setRecomendacao([...newRecomendacao]);
      let body = {
        cpfcnpj: session.cpfcnpj,
        idoferta: idoferta,
        origem: "zoomboxapp",
        idlojaexterno: session.idlojaexterno
      };

      let endpointApi = !!apiAtivaDescontoDev && apiAtivaDescontoDev === true ? '/dev/desconto/ativar' : '/desconto/ativar'

      const response = await postAtivaDesconto(endpointApi, {
        data: body,
        headers: {
          idvarejista: session.idvarejista,
          "x-api-key": session.xapikey,
        },
      });

      if (JSON.stringify(response.data).indexOf("Erro") > -1) {
        console.log("Erro ativação desconto *IF*");
        newRecomendacao[indexProduto].ativado = false;
        newRecomendacao[indexProduto].dataativacao = "";
        setRecomendacao([...newRecomendacao]);
      } else {
        newRecomendacao[indexProduto].ativado = true;
        setRecomendacao([...newRecomendacao]);
        analyticsEvent("ativaoferta");
      }
    } catch (error) {
      newRecomendacao[indexProduto].ativado = false;
      newRecomendacao[indexProduto].dataativacao = "";
      setRecomendacao([...newRecomendacao]);
      console.log(error, "Error ativação de desconto.");
    }
  };

  const ativaTodosDescontos = async () => {
    let newDescontos = recomendacao.filter(
      (data) => data.ativado === false && data.idtiporecomendacao === "1"
    );
    newDescontos.map((data) => {
      return ativaDesconto({ idoferta: data.idoferta });
    });

    return true;
  };

  const handleChangeLoja = (loja) => {
    const lojaselecionada = {
      idLoja: loja?.id,
      nomeLoja: loja?.nome,
      nomeLojaSelecionada: loja?.nome,
    };

    setLoja(lojaselecionada);
    localStorage.setItem("@LojaSelecionada::", JSON.stringify(lojaselecionada));
    analyticsEvent("alteraloja");
  };

  const addSelectedFilters = async ({ filtros }) => {
    const filterById = filtros.map((data) => data.id);

    filterById.map((data) => {
      return analyticsEvent(formataEventosFiltros([data]));
    });

    return setSelectedFiltros(filtros);
  };

  const updateWithFilters = async () => {
    const newRecomendacao = recomendacao;
    let filtered = [];
    let idtiporecomendacao = [];
    let idTopete = [];
    let clube = [];
    let expiraEmSete = [];
    let ativado = [];

    if (selectedFiltros) {
      const checkId = selectedFiltros
        .filter((data) => data.idtiporecomendacao)
        .map((data) => data.idtiporecomendacao);
      const checkIdTopete = selectedFiltros
        .filter((data) => data.id_classificacao_topete)
        .map((data) => data.id_classificacao_topete);
      const checkClube = selectedFiltros
        .filter((data) => data.clube)
        .map((data) => data.clube);
      const checkExpiraEmSete = selectedFiltros
        .filter((data) => data.expira)
        .map((data) => data.expira);
      const checkAtivado = selectedFiltros
        .filter((data) => data.ativado)
        .map((data) => data.ativado);
      idtiporecomendacao = checkId[0] === undefined ? [] : checkId;
      idTopete = checkIdTopete[0] === undefined ? [] : checkIdTopete;
      clube = checkClube[0] === undefined ? [] : checkClube;
      expiraEmSete =
        checkExpiraEmSete[0] === undefined ? [] : checkExpiraEmSete;
      ativado = checkAtivado[0] === undefined ? [] : checkAtivado;
    }

    if (selectedFiltros.length > 0) {
      for (let i = 0; i < idtiporecomendacao.length; i++) {
        let filteredLoop = newRecomendacao.filter((data) => {
          return data.idtiporecomendacao === idtiporecomendacao[i];
        });
        filtered = [...filtered, ...filteredLoop];
      }

      if (expiraEmSete.includes(true)) {
        if (filtered.length > 0) {
          filtered = filtered.filter((data) => {
            let dataAtual = moment(new Date());
            let validadeate = moment(new Date(data.validadeate));

            let diff = moment(new Date(validadeate), "DD/MM/YYYY").diff(
              new Date(dataAtual),
              "DD/MM/YYYY"
            );
            let diffInDays = moment.duration(diff).asDays();

            if (diffInDays <= 7) {
              return data;
            } else {
              return null;
            }
          });
        } else {
          filtered = newRecomendacao.filter((data) => {
            let dataAtual = moment(new Date());
            let validadeate = moment(new Date(data.validadeate));

            let diff = moment(new Date(validadeate), "DD/MM/YYYY").diff(
              new Date(dataAtual),
              "DD/MM/YYYY"
            );
            let diffInDays = moment.duration(diff).asDays();

            if (diffInDays <= 7) {
              return data;
            } else {
              return null;
            }
          });
        }
      }

      if (idTopete.includes("1") || idTopete.includes("2")) {
        if (idTopete.includes("1") && idTopete.includes("2")) {
          if (filtered.length > 0) {
            filtered = filtered.filter((data) => {
              return data.id_classificacao_topete === "3";
            });
          } else {
            filtered = newRecomendacao.filter((data) => {
              return data.id_classificacao_topete === "3";
            });
          }
        } else {
          if (filtered.length > 0) {
            for (let i = 0; i < idTopete.length; i++) {
              filtered = filtered.filter((data) => {
                return data.id_classificacao_topete === idTopete[i];
              });
            }
          } else {
            for (let i = 0; i < idTopete.length; i++) {
              filtered = newRecomendacao.filter((data) => {
                return data.id_classificacao_topete === idTopete[i];
              });
            }
          }
        }
      }

      if (clube.includes(true)) {
        if (filtered.length > 0) {
          filtered = filtered.filter((data) => {
            return data.clube === true;
          });
        } else {
          filtered = newRecomendacao.filter((data) => {
            return data.clube === true;
          });
        }
      }

      if (ativado.includes(true)) {
        if (filtered.length > 0) {
          filtered = filtered.filter((data) => {
            return data.ativado === true;
          });
        } else {
          filtered = newRecomendacao.filter((data) => {
            return data.ativado === true;
          });
        }
      }

      return setFilteredRecomendacao([...filtered]);
    } else {
      return setFilteredRecomendacao([...newRecomendacao]);
    }
  };

  const limpaFiltros = () => {
    setSelectedFiltros([]);
  };

  const ordernaProdutos = (id, produtos) => {
    if (id === 1) {
      analyticsEvent("ordenaaz");
      return produtos.sort(function (a, b) {
        if (
          removeAcento(a.nomeoferta.toLowerCase()) <
          removeAcento(b.nomeoferta.toLowerCase())
        ) {
          return -1;
        } else {
          return true;
        }
      });
    } else if (id === 2) {
      analyticsEvent("ordenaza");
      return produtos.sort(function (a, b) {
        if (
          removeAcento(a.nomeoferta.toLowerCase()) >
          removeAcento(b.nomeoferta.toLowerCase())
        ) {
          return -1;
        } else {
          return true;
        }
      });
    } else if (id === 3) {
      analyticsEvent("ordenarecentes");
      return produtos.sort(function (a, b) {
        return new Date(b.validadede) - new Date(a.validadede);
      });
    } else if (id === 4) {
      analyticsEvent("ordenaacabando");
      return produtos.sort(function (a, b) {
        return new Date(a.validadeate) - new Date(b.validadeate);
      });
    } else if (id === 0) {
      return produtos;
    }
  };

  const addOrderFilter = ({ order }) => {
    const newSelectedOrder = [];
    const checkSelectedOrder = selectedOrder;
    const check = checkSelectedOrder.every((data) => {
      return data.id !== order.id;
    });

    if (check) {
      selectedOrder.filter((data) => {
        return data.id === order.id;
      });
      newSelectedOrder.push(order);
      setSelectedOrder(newSelectedOrder);
    } else {
      selectedOrder.forEach((data, index) => {
        if (order.id === data.id) {
          selectedOrder.splice(index, 1);
        }
      });
      setSelectedOrder(newSelectedOrder);
    }
  };

  const viewDescricao = (data) => {
    setSelectedOferta(data);
  };

  return (
    <RecomendacaoContext.Provider
      value={{
        selectedFiltros,
        addSelectedFilters,
        filtros,
        limpaFiltros,
        handleChangeLoja,
        loja,
        setLoja,
        lojas,
        setLojas,
        recomendacao,
        filteredRecomendacao,
        ativaDesconto,
        ativaTodosDescontos,
        destaquesLabel,
        ofertasLabel,
        cashbackLabel,
        descontoExclusivoLabel,
        ordenacao,
        addOrderFilter,
        selectedOrder,
        ordernaProdutos,
        requestRecomendacao,
        inputSearch,
        setInputSearch,
        viewDescricao,
        selectedOferta,
      }}
    >
      {children}
    </RecomendacaoContext.Provider>
  );
}

export function useRecomendacao() {
  const context = useContext(RecomendacaoContext);

  const {
    selectedFiltros,
    addSelectedFilters,
    filtros,
    limpaFiltros,
    handleChangeLoja,
    loja,
    setLoja,
    lojas,
    setLojas,
    recomendacao,
    filteredRecomendacao,
    ativaDesconto,
    ativaTodosDescontos,
    destaquesLabel,
    ofertasLabel,
    cashbackLabel,
    descontoExclusivoLabel,
    ordenacao,
    addOrderFilter,
    selectedOrder,
    ordernaProdutos,
    requestRecomendacao,
    inputSearch,
    setInputSearch,
    viewDescricao,
    selectedOferta,
  } = context;

  return {
    selectedFiltros,
    addSelectedFilters,
    filtros,
    limpaFiltros,
    handleChangeLoja,
    loja,
    setLoja,
    lojas,
    setLojas,
    recomendacao,
    filteredRecomendacao,
    ativaDesconto,
    ativaTodosDescontos,
    destaquesLabel,
    ofertasLabel,
    cashbackLabel,
    descontoExclusivoLabel,
    ordenacao,
    addOrderFilter,
    selectedOrder,
    ordernaProdutos,
    requestRecomendacao,
    inputSearch,
    setInputSearch,
    viewDescricao,
    selectedOferta,
  };
}
